enum Path {
  Login = '/system/login',
  Home = '/system/home',
  PasswordReset = '/system/passwordReset',
  PasswordChange = '/system/passwordChange',
  UploadFail = '/system/uploadFail',
}

export default Path